const SHOWING_SETTING = {
  SHOW: '1',
  NONE: '0'
};

export default SHOWING_SETTING;
